<template>
  <SidebarUpgradePanelView :is-expanded="isExpanded" :limits="displayLimits" @upgrade="openLimitsModal" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SidebarUpgradePanel as SidebarUpgradePanelView } from '@/storybook/templates/limits';
import { useLimits } from '@/composables/useLimits';
import type { LimitUsage } from '@/storybook/templates/limits/types';

defineProps<{
  isExpanded: boolean;
}>();

// Parent sidebars own route/feature-flag/loading guards. This wrapper only adapts
// store-backed limits into the design-system panel and the design-system panel
// self-hides when the limits array is empty.
const { limitUsages, teamMembersLimitUsage, openLimitsModal } = useLimits();

const toDisplayLimit = (limit: LimitUsage) => ({
  ...limit,
  percentage: limit.max > 0 ? Math.min(Math.round((limit.current / limit.max) * 100), 100) : 0,
});

const displayLimits = computed(() => {
  const rows = limitUsages.value.map(toDisplayLimit);
  const memberRow = teamMembersLimitUsage.value;
  return memberRow ? [toDisplayLimit(memberRow), ...rows] : rows;
});
</script>
